import React from 'react';

import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import ReactDatePicker from 'react-datepicker';

import { call, classes } from 'utils';
import { toDate } from 'utils/time';

import styles from './DatePicker.module.scss';

const DatePicker = props => {
  const { name, error, helperText, disabled, inputProps } = props;
  const { readOnly } = inputProps || {};

  return (
    <FormControl
      required={props.required}
      fullWidth={props.fullWidth}
      error={error}
      disabled={disabled}
      style={readOnly ? { pointerEvents: 'none' } : undefined}
    >
      <InputLabel htmlFor={name} shrink>
        {props.label}
      </InputLabel>

      <ReactDatePicker
        selected={toDate(props.value)}
        className={styles.input}
        wrapperClassName={styles.wrapper}
        popperClassName={classes(
          styles.popper,
          props.hideDayOutsideMonth ? styles.hideDayOutsideMonth : ''
        )}
        peekNextMonth={false}
        onChange={value =>
          call(props.onChange, { type: 'change', target: { name, value: value || null } })
        }
        portalId="root"
        dateFormat="MMMM d, yyyy"
        disabledKeyboardNavigation
        disabled={disabled}
        {...inputProps}
      />

      <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
    </FormControl>
  );
};

export default DatePicker;
